module.exports = __webpack_public_path__ + "img/02—02—Device List > Dropdown > Wired > Selection.a7fd8f96.jpg";